import React from 'react'
import { Link } from 'react-router-dom'

export default function TopItem({cover, id, title, subtitle, category, author}) {
  return (
    <Link to={`/article/${id}`}  className='top-item-cont'>
        <img className='top-item-img' src={cover} alt="" />
        <div  className='top-item-text-cont'>
            <div className='row100'>
            {author ? <p className="top-item-author">Por {author}</p> : <></>}
            <p className="top-item-category"> {category} </p>
            </div>
    
            <p className='top-item-title'> {title} </p>
            {/* <p className='top-item-subtitle'> {subtitle} </p> */}

        </div>
    </Link>
  )
}
